import moment from 'moment';
import { cloneDeep, isArray } from 'lodash';

export default {
  data: () => ({
    dates: [],
    dateType: [],
  }),

  methods: {
    processDates(dates, dateType) {
      const startDate = moment(dates[0]);
      const endDate = moment(dates[1]);
      this.dateType = dateType;

      this.dates[0] = startDate.startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS');
      this.dates[1] = endDate.endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS');
    },
    setCommonFilterProperties() {
      return {
        startDate: this.dates[0],
        endDate: this.dates[1],
        dateType: this.dateType,
      };
    },
    stringToBoolean(value) {
      if (typeof value !== 'string') {
        console.error('Parâmetro inválido: esperado uma string.');
        return false;
      }

      const normalized = value.trim().toLowerCase();
      return normalized === 'true' || normalized === '1';
    },
    fetchAncestorByReferenceName(vm, refName) {
      let parent = vm.$parent;

      while (parent) {
        if (parent.$options.name === refName) {
          return parent;
        }
        parent = parent.$parent;
      }

      return null;
    },
    areEqualDeep(a, b) {
      if (a === b) return true;
      if (typeof a !== typeof b) {
        try {
          return JSON.stringify(a) === JSON.stringify(b);
        } catch(e) {
          return false;
        }
      }

      if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length) return false;
        return a.every((item, index) => this.areEqualDeep(item, b[index]));
      }

      if (a !== null && b !== null && typeof a === 'object' && typeof b === 'object') {
        const keysA = Object.keys(a);
        const keysB = Object.keys(b);
        if (keysA.length !== keysB.length) return false;

        return keysA.every(key => this.areEqualDeep(a[key], b[key]));
      }

      return a == b;
    },
    clearSessionStorage() {
      const keyTheme = 'theme';
      const valueTheme = sessionStorage.getItem(keyTheme);
      const keyToken = '@auth/token';
      const valueToken = sessionStorage.getItem(keyToken);
      const keyUser = '@auth/user';
      const valueUser = sessionStorage.getItem(keyUser);
      // const appOrigin = '@sdi/app_origin';
      // const userOrigin = sessionStorage.getItem(appOrigin);
      const selectedDate = 'selectedDate';
      const valueSelectedDate = sessionStorage.getItem(selectedDate);
      sessionStorage.clear();
      sessionStorage.setItem(keyToken, valueToken);
      sessionStorage.setItem(keyUser, valueUser);
      sessionStorage.setItem(selectedDate, valueSelectedDate);
      sessionStorage.setItem(keyTheme, valueTheme);
      // sessionStorage.setItem(appOrigin, !Boolean(userOrigin) ? "BACKOFFICE" : userOrigin);
    },
    buildSearchParams(filteredParams, page, itemsPerPage, sort) {
			const formattedFilterParams = cloneDeep(filteredParams)

			this.deleteEmptyParams(formattedFilterParams)

			return new URLSearchParams({
				...formattedFilterParams,
				page: page-1,
				size: itemsPerPage,
				sort: !!sort ? sort : "id,desc"
			})
		},
    deleteEmptyParams(params) {
			Object.keys(params).forEach((key) => {
				if (["", null, undefined].some(item => item === params[key])) delete params[key]
			})
		},
    getFilteredParams(params) {
			return Object.entries(params)
				.filter(([key, value]) => value && value !== "" && value !== null)
				.reduce((element, [key, value]) => ({ ...element, [key]: value }), {});
		},
    getFileType(filename) {
      if (!filename) return false;
      const parts = filename.split(".");
      return parts.length > 1 ? parts.pop() || false : false;
    },
    sanitize(value) {
      let searchMasks = [
        'FSCommand',
        'onAbort',
        'onActivate',
        'onAfterPrint',
        'onAfterUpdate',
        'onBeforeActivate',
        'onBeforeCopy',
        'onBeforeCut',
        'onBeforeDeactivate',
        'onBeforeEditFocus',
        'onBeforePaste',
        'onBeforePrint',
        'onBeforeUnload',
        'onBeforeUpdate',
        'onBegin',
        'onBlur',
        'onBounce',
        'onCellChange',
        'onChange',
        'onClick',
        'onContextMenu',
        'onControlSelect',
        'onCopy',
        'onCut',
        'onDataAvailable',
        'onDataSetChanged',
        'onDataSetComplete',
        'onDblClick',
        'onDeactivate',
        'onDrag',
        'onDragEnd',
        'onDragLeave',
        'onDragEnter',
        'onDragOver',
        'onDragDrop',
        'onDragStart',
        'onDrop',
        'onEnd',
        'onError',
        'onErrorUpdate',
        'onFilterChange',
        'onFinish',
        'onFocus',
        'onFocusIn',
        'onFocusOut',
        'onHashChange',
        'onHelp',
        'onInput',
        'onKeyDown',
        'onKeyPress',
        'onKeyUp',
        'onLayoutComplete',
        'onLoad',
        'onLoseCapture',
        'onMediaComplete',
        'onMediaError',
        'onMessage',
        'onMouseDown',
        'onMouseEnter',
        'onMouseLeave',
        'onMouseMove',
        'onMouseOut',
        'onMouseOver',
        'onMouseUp',
        'onMouseWheel',
        'onMove',
        'onMoveEnd',
        'onMoveStart',
        'onOffline',
        'onOnline',
        'onOutOfSync',
        'onPaste',
        'onPause',
        'onPopState',
        'onProgress',
        'onPropertyChange',
        'onReadyStateChange',
        'onRedo',
        'onRepeat',
        'onReset',
        'onResize',
        'onResizeEnd',
        'onResizeStart',
        'onResume',
        'onReverse',
        'onRowsEnter',
        'onRowExit',
        'onRowDelete',
        'onRowInserted',
        'onScroll',
        'onSeek',
        'onSelect',
        'onSelectionChange',
        'onSelectStart',
        'onStart',
        'onStop',
        'onStorage',
        'onSyncRestored',
        'onSubmit',
        'onTimeError',
        'onTrackChange',
        'onUndo',
        'onUnload',
        'onURLFlip',
        'seekSegmentTime'
      ];

      if(value) {
        for(const searchMask of searchMasks) {
          const regEx = new RegExp(searchMask, "ig");
          const replaceMask = '';
          value = value.replace(regEx, replaceMask);
        }
      }

      return value;
    },
    normalizeIds(ids) {
      let normalizedIds;
      if (ids && isArray(ids)) {
        normalizedIds = ids.join(",");
      } else if (ids) {
        normalizedIds = String(ids);
      }
      return normalizedIds;
    }
  },

  beforeDestroy() {
    this.dates = [];
    this.dateType = [];
  }
}
